type ErrorAction = 'creating' | 'deleting' | 'updating';

export type ErrorType = 'duplicate' | 'form_validation' | 'default';

interface ErrorClassification {
  id: string;
  actions: ErrorAction[];
  disableFooterButtons: boolean;
  errorKeys: string[];
  statusCode?: number;
  type: ErrorType;
}

export const ERROR_COMBINATIONS: ErrorClassification[] = [
  {
    id: 'duplicate_subscription',
    actions: ['creating'],
    errorKeys: ['subscription_has_existing_subscriber', 'detail'],
    statusCode: 422,
    type: 'duplicate',
    disableFooterButtons: true
  },
  {
    id: 'form_validation_recurrence',
    actions: ['creating', 'updating'],
    errorKeys: ['recurrence'],
    statusCode: 422,
    type: 'form_validation',
    disableFooterButtons: false
  }
];

export const findErrorClassification = (error: ScheduledSendError): ErrorClassification | null => {
  return (
    ERROR_COMBINATIONS.find((combination) => {
      const actionMatch = combination.actions.includes(error.action);
      const errorKeyMatch = combination.errorKeys.includes(error.errorKey || '');
      const statusCodeMatch = !combination.statusCode || combination.statusCode === error.statusCode;

      return actionMatch && errorKeyMatch && statusCodeMatch;
    }) || null
  );
};

export interface ScheduledSendError {
  action: ErrorAction;
  errorKey?: string;
  statusCode?: number;
}

interface ErrorResponse {
  response?: {
    json(): Promise<any>;
    status?: number;
  };
  message?: string;
}

export interface ErrorHandlerResult {
  success: boolean;
  error?: any;
  errorDetails?: any;
  statusCode?: number;
  errorKey?: string;
  type?: string;
}

export const errorHandler = async (
  error: ErrorResponse,
  errorLogPrefix: string
): Promise<ErrorHandlerResult> => {
  try {
    if (error.response) {
      const errorDetails = await error.response.json();
      console.error(`${errorLogPrefix}`, errorDetails);
      return {
        success: false,
        error,
        errorDetails,
        errorKey: Object.keys(errorDetails?.errors || {})[0],
        statusCode: error.response.status
      };
    } else {
      console.error(`${errorLogPrefix}`, error);
      return {
        success: false,
        error
      };
    }
  } catch (parseError) {
    console.error(`${errorLogPrefix} - Failed to parse error response:`, parseError);
    return {
      success: false,
      error
    };
  }
};
